import ReactDOM from 'react-dom';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GATE_TYPES } from './helper';
import { Button, Modal } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

export default function SaveSettingsButton({ gates, hasLeads, isSaving, savedGates, onClick }) {
  const [openModal, setOpenModal] = useState(false);

  // We are not completely sure why but this needs to be an state, otherwise this button is mounted twice
  // by react portal in some specific scenarios
  const [accessSettingsSaveContainer] = useState(document.getElementById('access-settings-save'));
  let isDirty = false;

  Object.keys(gates).forEach((gateKey) => {
    const gateTypesInProgress = gates[gateKey][GATE_TYPES.IN_PROGRESS].map(gate => gate.gateType);
    const savedGateTypesInProgress = savedGates[gateKey][GATE_TYPES.IN_PROGRESS].map(gate => gate.gateType);

    const difference1 = gateTypesInProgress.filter(gateType => !savedGateTypesInProgress.includes(gateType));
    const difference2 = savedGateTypesInProgress.filter(gateType => !gateTypesInProgress.includes(gateType));
    if (difference1.length > 0 || difference2.length > 0) isDirty = true;
  });

  function handleButtonClick() {
    if (isDirty && hasLeads) {
      setOpenModal(true);
    } else {
      onClick();
    }
  }

  function submitModal() {
    setOpenModal(false);
    onClick();
  }

  if (!accessSettingsSaveContainer) return null;

  return (
    <React.Fragment>
      <Modal show={openModal}>
        <Modal.Body className="modal-padding d-flex flex-column gap-5 justify-content-center align-items-center">

          <h6 className="m-0 d-flex align-items-center justify-content-center gap-2">
            <FontAwesomeIcon className="icon-gradient" icon={faCircleExclamation} />
            Access Level Modification
          </h6>
          <div className="spaced-text">
            You are about to change the access levels for your documents.
            This action may cause disruptions for your viewers.
            Users with access may experience changes in their permissions, leading to potential viewing limitations.
          </div>
          <div>
            <Button variant="ghost" onClick={() => setOpenModal(false)}>Cancel</Button>
            <Button onClick={submitModal}>Proceed</Button>
          </div>
        </Modal.Body>

      </Modal>

      {ReactDOM.createPortal((
        <div className="gap-3 d-flex">
          <Button disabled={isSaving} type="button" onClick={handleButtonClick}>
            Save Access Settings
          </Button>
        </div>
      ), accessSettingsSaveContainer)}
    </React.Fragment>
  );
}

SaveSettingsButton.propTypes = {
  gates: PropTypes.object,
  hasLeads: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  savedGates: PropTypes.object,
  onClick: PropTypes.func.isRequired
};
